"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setUserAttributes(attributes) {
    var _a, _b, _c;
    if (!((_a = window.puiFaro) === null || _a === void 0 ? void 0 : _a.api)) {
        return;
    }
    const currentUser = (_c = (_b = window.puiFaro.metas) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.user;
    // Check for attribute overwriting
    Object.keys(attributes).forEach((key) => {
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) && Object.hasOwnProperty.call(currentUser.attributes, key)) {
            // eslint-disable-next-line no-console
            console.warn(`[Faro] User attribute "${key}" is being overwritten.`);
        }
    });
    window.puiFaro.api.setUser(Object.assign(Object.assign({}, currentUser), { attributes: Object.assign(Object.assign({}, attributes), currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) }));
}
exports.default = setUserAttributes;
//# sourceMappingURL=setUserAttributes.js.map